import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';
import { mapEnumValueForFilter } from '../util/update-delivery-status-property-for-filter';

export class GMBImportSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    const companyName = updatedSchema.properties.CompanyName;
    companyName.title = this.i18n.getString('LocationData_Grid_ColumnTitle_CompanyName');

    const statusProperty = updatedSchema.properties.Status;

    const statusEnumSet = ['Active', 'Deleted'];
    statusProperty.enum = _.map(statusEnumSet, value => mapEnumValueForFilter('AdExtensionStatus', value));

    const propWhitelist = _.compact(['CompanyName']);

    updatedSchema.properties = _.pick(
      updatedSchema.properties,
      prop => _.contains(propWhitelist, prop.property)
    );

    return updatedSchema;
  }
}
